import './App.css';
import ExperimentsTable from './components/Analysis/ExperimentsTable';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import React from 'react';
import NavBar from './components/NavBar/NavBar';
import Input from './components/Input';
import ManualInput from './components/ManualInput/ManualInput';
import Auth from './components/Login/Auth';
import ProtectedRoute from './components/Login/ProtectedRoute';
import Planning from './components/Planning/Planning';
import Operation from './components/Operation/Operation';
import Account from './components/Account/Account';
import Configuration from './components/Account/Configuration'; 

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

function AppContent() {

  return (
    <>
      <NavBar />

      <Routes>
        <Route path="/" element={<Auth />} />
        <Route path="/comparative-analysis" element={
          <ProtectedRoute>
            <ExperimentsTable />
          </ProtectedRoute>
          } />
        <Route path="/home" element={
          <ProtectedRoute><Input /></ProtectedRoute>
          } />
        <Route path="/manual_input" element={
          <ProtectedRoute><ManualInput /></ProtectedRoute>
          } />
        <Route path="/operation/:userId/:experimentId/:scenarioId" element={
        <ProtectedRoute><Operation /></ProtectedRoute>
        } />
        <Route path="/planning/:userId/:experimentId/:scenarioId" element={
        <ProtectedRoute><Planning /></ProtectedRoute>
        } />
        <Route path="/account" element={
        <ProtectedRoute><Account /></ProtectedRoute>
        } />
        <Route path="/config-settings" element={
        <ProtectedRoute><Configuration /></ProtectedRoute>
        } />
      </Routes>
    </>

  );
}

export default App;

